<template>
  <div class="">
    <p class="text-center" style="margin-bottom:12px;font-size:14px;">选择咨询师及排班</p>
    <el-tabs tab-position="left" style="">
      <el-tab-pane v-for="teacherScheduleDay in teacherScheduleDays" :key="teacherScheduleDay.teacher.id">
        <span slot="label" class="tabTitle">{{ teacherScheduleDay.teacher.teacherName }}</span>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-avatar shape="square" :size="72" :src="teacherScheduleDay.teacher.headImage"></el-avatar>
          </el-col>
          <el-col :span="16">
            <br>
            {{ teacherScheduleDay.teacher.teacherName }}
          </el-col>
        </el-row>
        <el-collapse v-model="activeTeacherInfo">
          <el-collapse-item title="自我介绍" name="intro">
            <p>{{ teacherScheduleDay.teacher.intro }}</p>
          </el-collapse-item>
          <el-collapse-item title="资历" name="experience">
            <p>{{ teacherScheduleDay.teacher.experience }}</p>
          </el-collapse-item>
        </el-collapse>
        <p style="margin-top:24px;">排班时间</p>
        <br>
        <div v-if="teacherScheduleDay.scheduleDayVOs.length>0">
          <el-row v-for="scheduleDayVO in teacherScheduleDay.scheduleDayVOs" :key="scheduleDayVO.planDate"
                  style="margin-bottom:12px;">
            <el-col :span="16"
                    style="color:#303133;background-color:#D3DAF4;height:32px;padding:7px 10px;border-radius: 4px 0 0 4px ;">
              {{ dateAndWeek(scheduleDayVO) }}
            </el-col>
            <el-col :span="8">
              <el-button type="primary" :disabled="!canAppoint(scheduleDayVO)"
                         @click="selectScheduleUI(scheduleDayVO.listSche)"
                         style="padding: 9px 20px;border: none;border-radius: 0 4px 4px 0;width:100%">
                {{ canAppointInfo(scheduleDayVO) }}
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <el-row style="color: rgb(48, 49, 51);">（无排班）</el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
    <DialogSelectSchedule v-if="dialogSelectSchedule" :listSche="listSche" @cancel-selectSchedule="cancelSelectSchedule"
                          @select-schedule="selectSchedule"></DialogSelectSchedule>
    <DialogConfirmSchedule v-if="dialogConfirmSchedule" :schedule="schedule"
                           @cancel-confirmSchedule="cancelConfirmSchedule"
                           @confirm-schedule="confirmSchedule"></DialogConfirmSchedule>
  </div>
</template>

<script>
import {mapState} from "vuex";
import qs from "qs";
import HttpRequest from "@/utils/request";
import {tomorrow, daysLater} from "@/utils/date.js";
import DialogSelectSchedule from '@/components/dialogSelectSchedule'
import DialogConfirmSchedule from '@/components/dialogConfirmSchedule'

export default {
  components: {
    DialogSelectSchedule,
    DialogConfirmSchedule,
  },
  data() {
    return {
      dialogSelectSchedule: false,
      dialogConfirmSchedule: false,
      reInfo: false,
      teacherScheduleDays: [],
      activeTeacherInfo: ['intro', 'experience'],
      listSche: [],
      schedule: {},
      startDate: '',
      endDate: '',
      //
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  mounted() {
    document.title = '我要预约'
    this.startDate = tomorrow().Format("yyyy-MM-dd");
    this.endDate = daysLater(14).Format("yyyy-MM-dd");
    this.getTeacherScheduleDays();
  },
  methods: {
    dateAndWeek(scheduleDayVO) {
      return scheduleDayVO.planDate + ' ' + scheduleDayVO.weekDay;
    },
    countCanAppoint(scheduleDayVO) {
      let count = 0;
      let listSche = scheduleDayVO.listSche;
      listSche.forEach(function (schedule) {
        if (schedule.status == 10 || schedule.status == 31 || schedule.room.type == 1) {  //新加的，或是来访取消的，或者室团辅的
          count++;
        }
      });
      return count;
    },
    canAppointInfo(scheduleDayVO) {
      let count = this.countCanAppoint(scheduleDayVO);
      return count == 0 ? '已约满' : '可约' + count
    },
    canAppoint(scheduleDayVO) {
      let count = this.countCanAppoint(scheduleDayVO);
      return count == 0 ? false : true
    },
    getTeacherScheduleDays() {
      let url = "/constub/getTeacherScheduleDays";
      let data = {token: this.student.token, startDate: this.startDate, endDate: this.endDate};
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          this.teacherScheduleDays = res.data;
        } else {
          this.$alert(res.result.message, {
            confirmButtonText: '确定',
            showClose: false,
          });
        }
      });
    },
    selectScheduleUI(listSche) {
      this.listSche = listSche.filter((schedule) => {
        return schedule.status == 10 || schedule.status == 31 || schedule.room.type == 1;
      });
      this.dialogSelectSchedule = true;
    },
    cancelSelectSchedule() {
      this.dialogSelectSchedule = false;
    },
    selectSchedule(schedule) {
      this.schedule = schedule;
      this.dialogConfirmSchedule = true;
    },
    cancelConfirmSchedule() {
      this.dialogConfirmSchedule = false;
    },
    confirmSchedule() {
      let url = "/constub/getDoingCase";
      let data = {token: this.student.token, teacherId: this.schedule.teacher.id};
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          let cases = res.data;
          if (cases && cases.preQuiz) {
            this.addAppoint();
          } else {
            this.$alert('首次咨询前，请先填写咨询方案前置问卷', {
              showClose: false,
              confirmButtonText: '继续',
              callback: action => {
                sessionStorage.setItem("addAppoint", JSON.stringify(this.schedule));
                this.$router.push('/fillPreQuiz')
              }
            });
          }
        } else {
          this.$alert(res.result.message, {
            confirmButtonText: '确定',
            showClose: false,
          });
        }
      });
    },
    addAppoint() {
      let url = "/constub/addAppoint";
      let data = {token: this.student.token, scheduleId: this.schedule.id};
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          this.$router.push('/appointSuccess?scheduleId=' + this.schedule.id + '&pathfrom=home')
        } else {
          this.$alert(res.result.message, {
            confirmButtonText: '确定',
            showClose: false,
          });
        }
      });
    }
  }
};
</script>

<style scoped>
>>> .el-tabs__item.is-active {
  background-color: #fff;
}

>>> .el-tabs__active-bar {
  background-color: #fff;
}

>>> .el-tabs__content {
  background-color: #fff;
  padding: 12px;
}

>>> .el-tabs__item {
  padding: 0 10px;
}

>>> .el-tabs--left .el-tabs__header.is-left {
  margin-right: 0px;
}

>>> .el-tabs--left .el-tabs__item.is-left {
  text-align: center;
}

>>> .el-tabs__item:hover, .el-tabs__item:is-active {
  color: #303133;
}

>>> .el-collapse-item__header {
  height: 36px;
  line-height: 36px;
}

p {
  font-size: 12px;
  color: #303133;
}

.text p {
  line-height: 24px;
}

.borderrd {
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
}
</style>
